<template>
  <div class="login">
    <LoginMain/>
  </div>
</template>

<script>
import LoginMain from '@/components/LoginMain.vue'

export default {
  components: {
    LoginMain
  }
}
</script>
